import React, { useState } from 'react';
import { Form, Input, notification } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '../ui/button';
import { api } from '../../api';

const FormWrapper = styled.div`
  width: 400px;
  margin: auto;
  margin-top: 50px;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  h2,
  h5 {
    text-align: center;
    margin: 0px 0px 8px 0px;
  }
  h5 {
    margin: 0px 0px 2em 0px;
  }
`;

interface IForm {
  email: string;
  password: string;
}

export const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notifApi, contextHolder] = notification.useNotification();

  // TODO: Refactor out. Make it reusable
  const successNotification = () => {
    notifApi.success({
      message: 'Successfully sent reset password email',
      description: 'Please check your email for further instructions',
      placement: 'topRight',
      onClose: () => {
        navigate('/');
      },
      duration: 1,
    });
  };
  const failNotification = (message: string) => {
    notifApi.error({
      message: `Failed to send reset password email`,
      description: `An error occurred: ${message}`,
      placement: 'topRight',
      onClose: () => {},
      duration: 1,
    });
  };

  const onSubmit = (values: IForm) => {
    const { email } = values;
    if (!email) {
      return;
    }

    setLoading(true);

    api.auth
      .forgotPassword(email)
      .then(() => {
        successNotification();
      })
      .catch((error) => {
        console.error(error);
        failNotification(error.response?.data?.message ?? 'Please try again');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {contextHolder}

      <FormWrapper>
        <h2>Forgot Password</h2>
        <h5>
          Already have an account? <Link to={'/login'}>Log in</Link>
        </h5>
        <Form
          name="form-forgot-pwd"
          onFinish={onSubmit}
          initialValues={{ remember: true }}
          scrollToFirstError
          disabled={loading}
        >
          <Form.Item
            name="email"
            rules={[
              {
                type: 'email',
                message: 'The input is not valid E-mail!',
              },
              {
                required: true,
                message: 'Please input your E-mail!',
              },
            ]}
          >
            <Input
              prefix={<MailOutlined className="site-form-item-icon" />}
              placeholder="Email"
            />
          </Form.Item>

          <Form.Item>
            <Button type="submit" variant="default" className="w-full">
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </FormWrapper>
    </>
  );
};
